<ng-container *ngIf="portalLead.salesAgent">
  <ds-card class="mt-4 flex-column align-items-center agent">
    <img [src]="portalLead.salesAgent.picture" alt="agent" class="picture" />

    <p class="mt-6 text-align-center">
      <b data-id="fullname">{{ portalLead.salesAgent.fullName }}</b
      >, your Travel Expert, will reach out soon to discuss your trip<br
        class="d-none d-md-inline"
      />
      and savings. Giving {{ portalLead.salesAgent.fullName | getFirstName }} your trip details will
      help us save you money.
    </p>

    <div class="d-flex justify-content-center flex-wrap mt-2">
      <div class="px-2 py-1 badge m-1">
        <p data-id="deals">{{ portalLead.salesAgent.deals }} planned trips</p>
      </div>

      <div class="px-2 py-1 badge m-1">
        <p data-id="avg-savings">
          Saves clients
          <span [innerHTML]="portalLead.salesAgent.avgSavings | portalCurrency"></span> on average
        </p>
      </div>

      <div class="px-2 py-1 badge m-1">
        <p>97% client happiness score</p>
      </div>
    </div>
  </ds-card>

  <reviews [salesAgent]="portalLead.salesAgent" class="my-4 my-md-8 mx-4 mx-md-0" />
</ng-container>
